import { useStatsigUserSync } from '@/hooks/useStatsigUser';

/**
 * Component that ensures Statsig user is synchronized with app user
 * Place this inside StatsigProvider
 */
export const StatsigUserSync = ({ children }: { children: React.ReactNode }) => {
  useStatsigUserSync();
  return <>{children}</>;
};
